export default "__VITE_ASSET__a529e539__"